/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = { WARNING: 'WARNING', ERROR: 'ERROR', SUCCESS: 'SUCCESS' }; export default Keys;